const entriliaEmailDomains = ["entrilia.com", "entrilia51.dev", "aquileia.dev"];

const getEmailDomain = (email: string) => email.split("@")[1]?.toLowerCase() ?? "";

export const isExternalUserEmail = (email: string, organizationEmailDomains: string[]) => {
  const emailDomain = getEmailDomain(email);
  if (!emailDomain) {
    return true;
  }

  const internalEmailDomains = [...entriliaEmailDomains, ...organizationEmailDomains.map((d) => d.toLowerCase())];
  return !internalEmailDomains.includes(emailDomain);
};
